/* eslint-disable no-unused-vars*/
import React, { Fragment } from 'react';
import { useLocation } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { Card } from 'antd';
import CreateAnnounceOwner from 'components/AnnounceOwner/create.announceOwner';
import { HasAccess } from '@permify/react-role';
import { ErrorPage404 } from 'common/Error/error.common';

const AnnounceOwnerCreatePage = () => {
  const location = useLocation();
  const locationSplit = location?.pathname.split('/');
  let id = null;
  if (location?.pathname.includes('edit')) {
    id = Number(locationSplit[4]);
  }

  return (
    <Fragment>
      <Helmet>
        <title>{id ? 'ข้อมูลแจ้ง | ประกาศข้อมูล' : 'ข้อมูลแจ้ง | ประกาศข้อมูล'}</title>
      </Helmet>
      <HasAccess roles={['Owner']} renderAuthFailed={<ErrorPage404 />}>
        <Card title={`${id ? 'ข้อมูลแจ้ง | ประกาศข้อมูล' : 'ข้อมูลแจ้ง | ประกาศข้อมูล'}`}>
          <CreateAnnounceOwner id={Number(id)} />
        </Card>
      </HasAccess>
    </Fragment>
  );
};

export default AnnounceOwnerCreatePage;
